import axios from "axios";

import { requestHandler, successHandler, errorHandler } from "../interceptors";

const normalizeBase = (url) => (url || "").replace(/\/$/, "");

/**
 * Company portal API base. Paths in apis are relative (e.g. `/company_users`).
 * Set `REACT_APP_COMPANY_PORTAL_API_BASE_URL` (no trailing slash).
 */
export const resolveCompanyPortalBaseURL = () =>
  normalizeBase(process.env.REACT_APP_COMPANY_PORTAL_API_BASE_URL);

export const resolveClientPortalBaseURL = () =>
  normalizeBase(process.env.REACT_APP_CLIENT_PORTAL_API_BASE_URL);

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Handle request process
axiosInstance.interceptors.request.use((request) => requestHandler(request));

// Handle response process
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export const axiosCompanyPortalInstance = axios.create({
  baseURL: resolveCompanyPortalBaseURL(),
});

axiosCompanyPortalInstance.interceptors.request.use((request) =>
  requestHandler(request)
);
axiosCompanyPortalInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export const axiosClientPortalInstance = axios.create({
  baseURL: resolveClientPortalBaseURL(),
});

axiosClientPortalInstance.interceptors.request.use((request) =>
  requestHandler(request)
);
axiosClientPortalInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export const axiosUserAppInstance = axios.create({
  baseURL: process.env.REACT_APP_USER_APP_API_BASE_URL,
});

// Handle request process
axiosUserAppInstance.interceptors.request.use((request) =>
  requestHandler(request)
);

// Handle response process
axiosUserAppInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);
